// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"a6cc1af5","1029":"6e15c331","8042":"536d5763","8090":"a46a981c","9521":"4d223374"}[chunkId] + ".chunk.css";
};